export default __webpack_public_path__ + "static/sample-e1868b077e1b506701fd9420c8f0f267.jpg";